<template>
  <div class="pad-3">
    <div class="bb-container bb-container--lista">
      <h1 class="header-1">{{ $t("affiliationPolicy.affiliationPolicy", lang) }}</h1>
      <div class="post-entry">
        <p>
          {{ $t("affiliationPolicy.desc1", lang) }}
        </p>
        <p>
          {{ $t("affiliationPolicy.desc2", lang) }}
        </p>
        <h3><strong>{{ $t("affiliationPolicy.affiliatesTitle", lang) }}</strong></h3>
        <p>
          {{ $t("affiliationPolicy.affiliatesText1", lang) }}
        </p>
        <p>
          {{ $t("affiliationPolicy.affiliatesText2", lang) }}
        </p>
        <h3><strong>{{ $t("affiliationPolicy.advertisingTitle", lang) }}</strong></h3>
        <p>
          {{ $t("affiliationPolicy.advertisingText1", lang) }}
        </p>
        <p>
          {{ $t("affiliationPolicy.advertisingText2", lang) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { buildSeoMetaInfo } from "../../seo/buildSeoMetaInfo.js";
import { HTML_LANG_MAP } from "../../seo/langMaps.js";

const URL_ALTS = {
  "es": "https://www.hellobb.net/afiliacion-y-publicidad",
  "fr-FR": "https://www.hellobb.net/affiliation-et-publicite",
  "it-IT": "https://www.hellobb.net/affiliazione-e-pubblicita",
  "pt-BR": "https://www.hellobb.net/afiliacao-e-publicidade",
  "nl-NL": "https://www.hellobb.net/affiliatie-en-reclame",
  "de-DE": "https://www.hellobb.net/affiliation-und-werbung",
  "en-GB": "https://www.hellobb.net/affiliation-and-advertising",
  "x-default": "https://www.hellobb.net/afiliacion-y-publicidad",
}
export default {
  name: "AdvertisingAndAffiliation",
  metaInfo() {
    return buildSeoMetaInfo({
      vm: this,
      alts: URL_ALTS,
      appLang: this.lang,
      htmlLangMap: HTML_LANG_MAP,
      title: this.$t("affiliationPolicy.metaTitle", this.lang),
      description: this.$t("affiliationPolicy.metaDescription", this.lang),
    });
  },
  computed: {
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    }
  }
};
</script>
